import type { FaireProductEntity } from "../../entity_types/product";

export const p_g2ady2p3gs: FaireProductEntity = {
  token: "p_g2ady2p3gs",
  type: "product",
  name: "Techno Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/65c16516fb5cb238c96074ebb1fb5c3f17203d4f29b88e2979d9ff3f034dcd0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e8841679d4b194cb96a99164625917a54927a47e1bd71e2f25ca00843a0620f.jpeg",
    "https://cdn.faire.com/fastly/fa3cff23319bc3b35cd8c05231518d2acaebae354a524a2af4f3227e5932b34e.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/a900b3865c5234878040661bd3e827e472947cc11da2421725e2fd238c54a781.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are perfect for the friend that knows the subtle sonic differences between the Detroit and Berlin techno scenes, and goes into a dance trance either way.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:06.591Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
